import tw from 'twin.macro'

const MenuLi = tw.li`px-4`

export default MenuLi
